import React, { useState } from "react";

const Pendaftaran: React.FC = () => {
  const [form, setForm] = useState({
    nama: "",
    filantropi: "",
    nomor: "",
    email: "",
    alamat: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await fetch("https://script.google.com/macros/s/AKfycby0fkR3enqtJsqbpx8_Wrr4tmjViH6W1JPr55-HiyxjcbIBA3ACaYm3A0BXAlPdhisLWA/exec", {
        method: "POST",
        body: JSON.stringify(form),
      });

      setForm({
        nama: "",
        filantropi: "",
        nomor: "",
        email: "",
        alamat: "",
      });

      setSuccess(true);
    } catch {
      alert("Gagal mengirim data ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* FORM */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-5xl mx-auto bg-white p-10 rounded-3xl shadow-xl">
          <div className=" mb-10">
            <h1 className="text-3xl md:text-4xl font-bold text-center max-sm:w-56 max-sm:mx-auto">
              Pendaftaran <span className="text-red-600 font-bilbo text-4xl  md:text-5xl ">Lembaga Sosial</span>
            </h1>

            <p className="mt-2 text-xs md:text-sm max-w-xl mx-auto text-center text-gray-600">Mari bergabung lembaga Forum Zakat, Filantropi, dan Humaitarian di Indonesia.</p>
          </div>

          <form onSubmit={handleSubmit} className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {/* LEFT */}
            <div className="space-y-4">
              <Input name="nama" value={form.nama} onChange={handleChange} placeholder="Nama Pendaftar" />
              <Input name="filantropi" value={form.filantropi} onChange={handleChange} placeholder="Nama Lembaga" />
              <Input name="nomor" value={form.nomor} onChange={handleChange} placeholder="Nomor WhatsApp" />
              <Input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Email" />
            </div>

            {/* RIGHT */}
            <div className="flex flex-col space-y-4">
              <textarea
                name="alamat"
                value={form.alamat}
                onChange={handleChange}
                placeholder="Alamat Filantropi"
                required
                className="w-full min-h-[200px] border border-gray-300 px-4 py-3 rounded-xl focus:ring-2 focus:ring-red-500 outline-none transition"
              />

              <button
                disabled={loading}
                className="bg-red-600 text-white py-4 rounded-xl font-semibold
                hover:bg-red-700 active:scale-95 transition-all duration-200
                disabled:opacity-60">
                {loading ? "Mengirim..." : "Daftar Sekarang"}
              </button>
            </div>
          </form>
        </div>
      </section>

      {/* SUCCESS POPUP */}
      <div
        className={`
          fixed inset-0 z-50 flex items-center justify-center
          bg-black/50 transition-opacity duration-300
          ${success ? "opacity-100 visible" : "opacity-0 invisible"}
        `}>
        <div
          className={`
            bg-white rounded-2xl p-8 w-[90%] max-w-md text-center
            transform transition-all duration-300 ease-out
            ${success ? "scale-100 translate-y-0 opacity-100" : "scale-90 translate-y-6 opacity-0"}
          `}>
          <div className="text-5xl mb-4 animate-bounce">🎉</div>
          <h2 className="text-2xl font-bold mb-2">Pendaftaran Berhasil</h2>
          <p className="text-gray-600 mb-6">Data filantropi kamu sudah kami terima 🙏</p>

          <button
            onClick={() => setSuccess(false)}
            className="bg-red-600 text-white px-6 py-3 rounded-xl
            hover:bg-red-700 active:scale-95 transition-all">
            Tutup
          </button>
        </div>
      </div>
    </>
  );
};

const Input = ({ type = "text", ...props }: React.InputHTMLAttributes<HTMLInputElement>) => (
  <input
    type={type}
    required
    className="w-full border border-gray-300 px-4 py-3 rounded-xl
    focus:ring-2 focus:ring-red-500 outline-none transition"
    {...props}
  />
);

export default Pendaftaran;
